import * as OvationsApi from 'core/ovations-api';

export const mockCertifiableAddress: OvationsApi.Types.CertifiableAddress = {
    address1: 'address1',
    address2: 'address2',
    city: 'city',
    state: 'state',
    zip: '12345',
    status: OvationsApi.Enums.AddressCertificationStatus.NonCertified,
    country: 'CAN',
};

export default mockCertifiableAddress;
